import { createReducer } from '@reduxjs/toolkit';
import { FailureType, TryFetchLogInfoState, TryFetchLogInfoStatus } from './types';
import { logInfoActions } from './actions';

export const SHARE_EXPIRED_HTTP_STATUS = 499;

const initialState: TryFetchLogInfoState = {
  status: TryFetchLogInfoStatus.NotStartedYet,
  failureType: FailureType.None,
  logInfo: undefined,
};

export const logInfoReducer = createReducer(initialState, builder =>
  builder
    .addCase(logInfoActions.tryFetchLogInfoStart, () => {
      return { ...initialState, status: TryFetchLogInfoStatus.InProgress };
    })
    .addCase(logInfoActions.tryFetchLogInfoSuccess, (_state, action) => {
      return {
        status: TryFetchLogInfoStatus.Succeeded,
        failureType: FailureType.None,
        logInfo: action.payload,
      };
    })
    .addCase(logInfoActions.tryFetchLogInfoFailure, (_state, action) => {
      let failureType: FailureType;
      switch (action.payload) {
        case 404:
          failureType = FailureType.LogNotFound;
          break;
        case 499:
          failureType = FailureType.ShareExpired;
          break;
        case 498:
          failureType = FailureType.NotSharedWithUser;
          break;
        default:
          failureType = FailureType.Unexpected;
          break;
      }
      return {
        ...initialState,
        status: TryFetchLogInfoStatus.Failed,
        failureType: failureType,
      };
    })
    .addDefaultCase(state => state),
);
